import { ReactNode } from "react"
// my imports:
import UI from "@/app/lib/ui/ui"
import { AnyGameObj } from "@/app/lib/game-state/game-types"
import PageInputs from "@/app/lib/input/page-inputs"
import { captureFocusedLetterBox } from "@/app/lib/input/capture-focused-letterBox"

type PageWrapperProps = {
    children: ReactNode,
    ui: UI,
    activeGame: AnyGameObj
    handleInputs?: boolean
}

export default function PageWrapper({ children, ui, activeGame, handleInputs = true } : PageWrapperProps) {
    const pageInputs = new PageInputs(
        activeGame,
        ui
    );
    let focusedPosition: { wordIndex: number, letterPosition: number } | null = null;

    return(
        <div className="pageWrapper"
            onPointerDown={() => {
                if (!handleInputs)
                    return;
                focusedPosition=captureFocusedLetterBox()
            }}

            onKeyDown={e => {
                if (!handleInputs)
                    return;
                pageInputs.handleShuffle(e) 
            }}
            onClick={e => {
                if (!handleInputs)
                    return;
                if (!focusedPosition) {
                    pageInputs.handleClick()
                }
            }}
        >
            <div
                className="contentGrid"
                tabIndex={0}
            >
                {children}
            </div>
        </div>
    )
}